<template>
  <div class="container">
    <!-- 内容循环展示 -->
    <div class="section" v-for="(content, index) in contents" :key="index">
      <template v-if="content.type === 'image'">
        <div class="image-container">
          <el-image class="full-image" :src="content.src" fit="cover"></el-image>
        </div>
        <div class="content-overlay" v-if="content.text">
          <h2 class="centered-text">{{ content.text }}</h2>
        </div>
      </template>
      <template v-else-if="content.type === 'video'">
        <div class="video-container">
          <video
            ref="video"
            class="video"
            :autoplay="index === 0"
            :loop="index === 0"
            @play="handleVideoPlay(index)"
            controls
          >
            <source :src="content.src" type="video/mp4" />
            您的浏览器不支持 HTML5 视频。
          </video>
        </div>
      </template>
      <template v-else-if="content.type === 'carousel'">
        <div class="carousel-container">
          <el-carousel :height="carouselHeight">
            <el-carousel-item v-for="(image, index) in content.images" :key="index">
              <el-image class="carousel-image" :src="image.src" fit="contain" @load="updateCarouselHeight"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contents: [
        { type: 'video', src: require('@/assets/video/kep-1.mp4') },
        { type: 'video', src: require('@/assets/video/kep-2.mp4') },
        { type: 'image', src: require('@/assets/images/kep1.jpg') },
        {
          type: 'carousel',
          images: [
            { src: require('@/assets/images/kep2-1.jpg') },
            { src: require('@/assets/images/kep2-2.jpg') },
            { src: require('@/assets/images/kep2-3.jpg') },
            { src: require('@/assets/images/kep2-4.jpg') },
            { src: require('@/assets/images/kep2-5.jpg') },
          ],
        },
        { type: 'image', src: require('@/assets/images/kep3.jpg') },
        {
          type: 'carousel',
          images: [
            { src: require('@/assets/images/kep4-1.jpg') },
            { src: require('@/assets/images/kep4-2.jpg') },
            { src: require('@/assets/images/kep4-3.jpg') },
            { src: require('@/assets/images/kep4-4.jpg') },
            { src: require('@/assets/images/kep4-5.jpg') },
          ],
        },
        { type: 'image', src: require('@/assets/images/kep5.jpg') },
        { type: 'image', src: require('@/assets/images/kep6.jpg') },
        { type: 'image', src: require('@/assets/images/kep7.jpg') },
        { type: 'image', src: require('@/assets/images/kep8.jpg') },
        { type: 'image', src: require('@/assets/images/kep9.jpg') },
        { type: 'image', src: require('@/assets/images/kep10.jpg') },
        { type: 'image', src: require('@/assets/images/kep11.jpg') },
        { type: 'image', src: require('@/assets/images/kep12.jpg') },
      ],
      carouselHeight: 'auto',
    }
  },
  methods: {
    handleVideoPlay(index) {
      if (index === 1) {
        this.$refs.video[0].pause()
      }
    },
    updateCarouselHeight(event) {
      const image = event.target
      this.carouselHeight = `${image.clientHeight}px`
    },
    handleResize() {
      const images = document.querySelectorAll('.carousel-image')
      let maxHeight = 0
      images.forEach(image => {
        if (image.clientHeight > maxHeight) {
          maxHeight = image.clientHeight
        }
      })
      this.carouselHeight = `${maxHeight}px`
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize() // 初始化时设置高度
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  overflow: hidden;
  text-align: center;
}
.section {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.full-image {
  width: 100%;
  height: auto;
  object-fit: cover;
}
.content-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
}
.centered-text {
  margin: 0;
  padding: 0;
  font-size: 2rem;
}
.video-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 确保视频按比例缩放并填充整个容器 */
}
.carousel-container {
  width: 100%;
  height: auto; /* 让轮播图容器高度自动适应图片 */
  overflow: hidden;
}
.carousel-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}
@media screen and (max-width: 768px) {
  .video {
    width: 100%;
    height: auto;
  }
}
</style>
